export class PodValidationDeliveryItem {
  public id: string;
  public line: number;
  public productId: string;
  public productDescription: string;
  public weight: number;
  public pieces: number;
  public additional: boolean;

  static fromDto(i): PodValidationDeliveryItem {
    return PodValidationDeliveryItem.init(i);
  }

  static copy(pod: PodValidationDeliveryItem): PodValidationDeliveryItem {
    return PodValidationDeliveryItem.init(pod);
  }

  private static init(pod: any): PodValidationDeliveryItem {
    const item = new PodValidationDeliveryItem();

    if (!pod) {
      return null;
    }

    item.id = pod.id;
    item.line = pod.line;
    item.productId = pod.productId;
    item.productDescription = pod.productDescription;
    item.weight = pod.weight;
    item.pieces = pod.pieces;
    item.additional = pod.additional;

    return item;
  }
}
